import { render } from "./create-task-view.vue?vue&type=template&id=72b9e7a6"
import script from "./create-task-view.vue?vue&type=script&lang=js"
export * from "./create-task-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__